import { useNavigate } from 'react-router-dom';
import { ClientForm } from '@/components/clients/ClientForm';
import { useCreateClient } from '@/hooks/useClients';
import type { ClientInput } from '@jobos/shared/types/client';

export default function NewClient() {
  const navigate = useNavigate();
  const { mutateAsync: createClient, isPending } = useCreateClient();

  const handleSubmit = async (data: ClientInput) => {
    const result = await createClient(data);
    navigate(`/clients/${result.id}`);
  };

  const handleCancel = () => {
    navigate('/clients');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto p-4 sm:p-6 lg:p-8">
        <div className="mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Create New Client
          </h1>
        </div>

        <div className="bg-white rounded-lg shadow p-4 sm:p-6">
          <ClientForm
            onSubmit={handleSubmit}
            isPending={isPending}
            submitButtonText="Create Client"
            onCancel={handleCancel}
          />
        </div>
      </div>
    </div>
  );
}
